export let PageType = /*#__PURE__*/function (PageType) {
  PageType["Archive"] = "archive";
  PageType["Article"] = "article";
  PageType["Author"] = "author";
  PageType["Authors"] = "authors";
  PageType["Explained"] = "explained";
  PageType["Games"] = "games";
  PageType["GamesCrosswords"] = "games_crosswords";
  PageType["Homepage"] = "homepage";
  PageType["Live"] = "live";
  PageType["Newsletter"] = "newsletter";
  PageType["NewsletterPreview"] = "newsletter_preview";
  PageType["Others"] = "others";
  PageType["Page"] = "page";
  PageType["Plus"] = "plus";
  PageType["Podcast"] = "podcast";
  PageType["Posties"] = "posties";
  PageType["PostiesArticle"] = "article_posties";
  PageType["PostiesKids"] = "content";
  PageType["PostiesParents"] = "brochure";
  PageType["PostiesSection"] = "section_posties";
  PageType["PostiesVideo"] = "video_posties";
  PageType["ScmpFilms"] = "scmp_films";
  PageType["Section"] = "section";
  PageType["Series"] = "series";
  PageType["Spotlight"] = "spotlight";
  PageType["StoryCard"] = "story-card";
  PageType["SubSection"] = "subsection";
  PageType["TalkingPost"] = "talking_post";
  PageType["Topic"] = "topic";
  PageType["TopicCollection"] = "topic_collection";
  PageType["Topics"] = "topics";
  return PageType;
}({});